import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
      <h1 mat-dialog-title>Confirmation</h1>
      <div mat-dialog-content>
          <p>Êtes-vous sûr de vouloir signer et envoyer votre déclaration à notre équipe ?</p>
          <br>
          <p>Toute modification ultérieure sera impossible</p>
      </div>
      <div mat-dialog-actions align="end" class="responsive-actions">
          <button mat-button (click)="onNoClick()">Non</button>
          <button mat-raised-button color="primary" (click)="onYesClick()" cdkFocusInitial>Oui</button>
      </div>
  `,
  styles: [
    `
      .responsive-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: flex-end;
      }
      @media (max-width: 600px) {
        .responsive-actions {
          flex-direction: column;
          width: 100%;
        }
        .responsive-actions button {
          width: 100%;
        }
      }
    `
  ]
})
export class ConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close({ ok: true });
  }
}
